import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Alert,
  Spinner,
  OverlayTrigger,
  Tooltip,
  Container,
} from "react-bootstrap";
import { FaCheck, FaClock, FaKey } from "react-icons/fa";
import Menubar from "./Menubar";
import BackgroundFooter from "./BackgroundFooter";
import "../ComponentsCss/Iam.css";
import "../ComponentsCss/SiemIntegration.css";
import { useNavigate } from "react-router-dom";
import { Toast, ToastContainer } from "react-bootstrap";
import NavigationBar from "./Nav";
import trendicon from "../Assets/Trendmicro.png";
import micrlogo from "../Assets/microsoft-365-logo.png";
import intruder from "../Assets/intruderlogo.png";
import { useAuth } from "../contexts/AuthContext";
import { logActivity ,getClientIP } from '../utils/activityLogApi';


const SiemIntegration = ({ userData }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    return JSON.parse(localStorage.getItem("isSidebarCollapsed")) || false;
  });
  // const [showPopup, setShowPopup] = useState(false);
  // const [isExpired, setIsExpired] = useState(false);
  const [generatedToken, setGeneratedToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [copiedField, setCopiedField] = useState("");
  const [region, setRegion] = useState(
    () => sessionStorage.getItem("userRegion") || "IN"
  );
 // const [statusLoading, setStatusLoading] = useState(true);
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [requestedTool, setRequestedTool] = useState("");
  const [sendingRequest, setSendingRequest] = useState(false);
const [showToast, setShowToast] = useState(false);
const [toastMessage, setToastMessage] = useState("");
// Add subscription states
const [subscriptionStatus, setSubscriptionStatus] = useState(null);
const [subscriptionLoading, setSubscriptionLoading] = useState(false);
const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
const [trialEndDate, setTrialEndDate] = useState(null);
const [checkingOutPayment, setCheckingOutPayment] = useState(false);
const [secondTrialUsed, setSecondTrialUsed] = useState(false);
const [subscriptionKey, setSubscriptionKey] = useState('');
const [isActivatingKey, setIsActivatingKey] = useState(false);
const [keyValidationError, setKeyValidationError] = useState('');

// Add these new state variables after your existing ones
const [activeConnections, setActiveConnections] = useState([]);
const [connectionsLoading, setConnectionsLoading] = useState(false);

const { profile } = useAuth();
const orgId = profile?.orgId;
  const userId = userData?.["cognito:username"];

  const navigate = useNavigate();
  const [clientIP, setClientIP] = useState('');
  useEffect(() => {
    getClientIP().then(ip => setClientIP(ip || '')).catch(() => setClientIP(''));
  }, []);
// ✅ Add this helper function after your state variables
const isValidKeyFormat = (key) => {
  if (!key || key.trim() === '') return false;
  
  // Validate the new format: SUS-[COUNTRY]-[RANDOM]-[DOMAIN]-[16-20 DIGITS]
  const keyPattern = /^SUS-[A-Z]{2}-\d{4,6}-[a-zA-Z0-9]+-\d{16,20}$/;
  return keyPattern.test(key.trim());
};

  useEffect(() => {
    if (!userId) return;

   
//    const fetchStatus = async () => {
//   try {
//     setStatusLoading(true);
//     const res = await fetch(
//       "https://ll4us4l32c.execute-api.eu-west-1.amazonaws.com/prod/api/user-status",
//       {
//         method: "GET",
//         headers: {
//           userId,
//           Region: region,
//         },
//       }
//     );
//     const data = await res.json();

//     const hasIntegrated = localStorage.getItem("siemApiIntegrated");

//     // ✅ Show popup if trial not started AND not already marked locally
//     if (!data.trialEndDate && !hasIntegrated) {
//       setShowPopup(true);
//     }

//     // ✅ Handle expired trial warning
//     if (data.showApiWarning) {
//       setIsExpired(true);
//       setShowPopup(true);
//     }
//   } catch (err) {
//     console.error("Failed to fetch status", err);
//   } finally {
//     setStatusLoading(false);
//   }
// };


    //  fetchStatus();

    
   

    const savedToken = localStorage.getItem("susanGeneratedToken");
    if (savedToken) {
      setGeneratedToken(savedToken);
    }
  }, [region, userId]);
// Add subscription checking useEffect
// useEffect(() => {
//   const checkOrgSubscription = async () => {
//     if (!userData?.["cognito:username"]) return;
    
//     try {
//       setSubscriptionLoading(true);
//       const res = await fetch('https://atw24p2ef8.execute-api.ap-southeast-2.amazonaws.com/prod/api/org/subscription-status', {
//         method: 'GET',
//         headers: {
//           'UserId': userData["cognito:username"],
//           'Region': sessionStorage.getItem('userRegion') || 'AP'
//         }
//       });
      
//       const data = await res.json();
//       setSubscriptionStatus(data.status);
//       setTrialEndDate(data.trialEnd);
//       setSecondTrialUsed(data.secondTrialUsed || false);
      
//       // ✅ ONLY SHOW SUBSCRIPTION MODAL - NO OLD SIEM POPUP
//      // ✅ SHOW SUBSCRIPTION MODAL FOR EXPIRED/CANCELED USERS
// if (['canceled', null].includes(data.status)) {
//   setShowSubscriptionModal(true);
// }

      
//     } catch (err) {
//       console.error('Failed to fetch subscription status:', err);
//     } finally {
//       setSubscriptionLoading(false);
//     }
//   };
  
//   checkOrgSubscription();
// }, [userData]);

// Add this useEffect after the subscription checking useEffect
useEffect(() => {
  if (userData?.["cognito:username"] && !subscriptionLoading) {
    fetchActiveConnections();
  }
}, [userData, subscriptionLoading]);


// Subscription action handlers
const handleStartTrial = async () => {
  try {
    const res = await fetch('https://7b3mrfutle.execute-api.ap-southeast-2.amazonaws.com/prod/api/billing/start-trial', {
      method: 'POST',
      headers: {
        'UserId': userData["cognito:username"],
        'Region': sessionStorage.getItem('userRegion') || 'IN'
      }
    });
    
    if (res.ok) {
      window.location.reload();
    } else {
      alert('Failed to start trial');
    }
  } catch (err) {
    alert('Failed to start trial');
  }
};
const handleStartSecondTrial = async () => {
  try {
    const res = await fetch('https://80gbnjdo0k.execute-api.ap-southeast-2.amazonaws.com/prod/api/billing/start-second-trial', {
      method: 'POST',
      headers: {
        'UserId': userData["cognito:username"],
        'Region': sessionStorage.getItem('userRegion') || 'IN'
      }
    });
    
    if (res.ok) {
      window.location.reload();
    } else {
      alert('Second trial not available or already used');
    }
  } catch (err) {
    alert('Failed to start second trial');
  }
};

const handleActivateSubscriptionKey = async () => {
  if (!subscriptionKey.trim()) {
    setKeyValidationError('Please enter a subscription key');
    return;
  }

  // ✅ Validate new key format: SUS-[COUNTRY]-[RANDOM]-[DOMAIN]-[16-20 DIGITS]
  const isValidKeyFormat = (key) => {
    const keyPattern = /^SUS-[A-Z]{2}-\d{4,6}-[a-zA-Z0-9]+-\d{16,20}$/;
    return keyPattern.test(key.trim());
  };

  if (!isValidKeyFormat(subscriptionKey)) {
    setKeyValidationError('Invalid key format. Please check your subscription key.');
    return;
  }

  setIsActivatingKey(true);
  setKeyValidationError('');
  
  try {
    const region = sessionStorage.getItem("userRegion") || "IN";
    const response = await fetch("https://l7rleysajb.execute-api.ap-southeast-2.amazonaws.com/prod/api/subscription/activate-key", { // ✅ Update with your correct endpoint
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'UserId': userData["cognito:username"],
        'Region': region
      },
      body: JSON.stringify({ subscriptionKey: subscriptionKey.trim() })
    });

    const data = await response.json();
    
    if (response.ok) {
      setToastMessage('🎉 Subscription activated! Premium features unlocked.');
      setShowToast(true);
      setShowSubscriptionModal(false);
      setSubscriptionKey('');
      window.location.reload();
    } else {
      // ✅ Handle specific error messages from backend
      const errorMessage = data.error || 'Invalid subscription key. Please check and try again.';
      setKeyValidationError(errorMessage);
      
      // Show different toast messages based on error type
      if (errorMessage.includes('domain')) {
        setToastMessage('❌ This subscription key is not valid for your domain');
      } else if (errorMessage.includes('expired')) {
        setToastMessage('❌ This subscription key has expired');
      } else if (errorMessage.includes('Invalid')) {
        setToastMessage('❌ Invalid subscription key');
      } else {
        setToastMessage('❌ ' + errorMessage);
      }
      setShowToast(true);
    }
  } catch (err) {
    console.error("Key activation failed", err);
    setKeyValidationError("Failed to activate subscription key. Please try again.");
    setToastMessage("❌ Network error. Please check your connection and try again.");
    setShowToast(true);
  } finally {
    setIsActivatingKey(false);
  }
};


const handleSubscriptionKeyEntry = () => {
  // Just show the modal - the key entry UI is already there
};



// const handleManageBilling = async () => {
//   try {
//     const response = await fetch('https://0shbfl9j5a.execute-api.eu-west-1.amazonaws.com/prod/api/billing/portal-session', {
//       method: 'POST',
//       headers: {
//         'UserId': userData["cognito:username"],
//         'Region': sessionStorage.getItem('userRegion') || 'IN'
//       }
//     });
    
//     const data = await response.json();
//     if (data.url) {
//       window.open(data.url, '_blank');
//     }
//   } catch (err) {
//     alert('Could not open billing portal');
//   }
// };
// Subscription banner rendering
const renderSubscriptionBanner = () => {
  if (subscriptionStatus === 'trialing' && trialEndDate) {
    const daysLeft = Math.floor((new Date(trialEndDate + 'Z') - new Date()) / (1000 * 60 * 60 * 24));
    const hoursLeft = Math.floor((new Date(trialEndDate + 'Z') - new Date()) / (1000 * 60 * 60));
    const isUrgent = daysLeft <= 3;
    
    const displayText = daysLeft > 0 ? `${daysLeft} days remaining` : `${hoursLeft} hours remaining`;
    
    return (
      <Alert variant={isUrgent ? "danger" : "warning"} className="mb-4">
        <div className="d-flex justify-content-between align-items-center gap-2">
          <div>
            <FaClock className="me-2" />
            <strong>Trial Active:</strong> {displayText}
            {isUrgent && <span className="text-danger ms-2">(Urgent: Trial ending soon!)</span>}
          </div>
          <Button 
            variant={isUrgent ? "btn btn-danger" : "btn btn-success"} 
            size="sm" 
            onClick={() => setShowSubscriptionModal(true)}
          >
            Enter Key / Extend
          </Button>
        </div>
      </Alert>
    );
  }
  
  if (subscriptionStatus === 'active') {
    return (
      <Alert variant="success" className="mb-4">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <FaCheck className="me-2" />
            <strong>Subscription Active:</strong> Premium features enabled
          </div>
          <Button 
          className="ms-2"
            variant="outline-success" 
            size="sm" 
            onClick={() => setShowSubscriptionModal(true)}
          >
            Manage Subscription
          </Button>
        </div>
      </Alert>
    );
  }
  
  return null;
};


  const handleSidebarToggle = () => {
    setIsSidebarCollapsed((prev) => !prev);
  };

  // const handlePopupYes = async () => {
  //   if (isExpired) {
  //     try {
  //       const response = await fetch(
  //         "https://b927huehog.execute-api.eu-west-1.amazonaws.com/prod/api/create-stripe-session",
  //         {
  //           method: "POST",
  //           headers: {
  //             userId,
  //             Region: region,
  //           },
  //         }
  //       );

  //       const data = await response.json();

  //       if (data.checkoutUrl) {
  //         window.location.href = data.checkoutUrl; // ✅ Redirect to Stripe Checkout
  //       } else {
  //         alert("Could not get Stripe URL");
  //       }
  //     } catch (err) {
  //       console.error("Stripe redirection failed", err);
  //       alert("Something went wrong while creating the payment session.");
  //     }
  //   } else {
  //     try {
  //       await fetch(
  //         "https://7b3mrfutle.execute-api.ap-southeast-2.amazonaws.com/prod/api/start-trial",
  //         {
  //           method: "POST",
  //           headers: {
  //             userId,
  //             Region: region,
  //           },
  //         }
  //       );
  //       localStorage.setItem("siemApiIntegrated", "true");
  //       window.location.reload();
  //       setShowPopup(false);
  //     } catch (err) {
  //       alert("Trial start failed");
  //     }
  //   }
  // };

  const handleDownloadPolicy = async (fileName) => {
    try {
      const response = await fetch(
        `https://i6keo3zos1.execute-api.ap-southeast-2.amazonaws.com/prod/?fileName=${encodeURIComponent(
          fileName
        )}`
      );
      const data = await response.json();

      if (data.url) {
        // Open the S3 pre-signed URL in a new tab or trigger download
        window.open(data.url, "_blank");
      } else {
        alert("No download URL returned.");
      }
    } catch (error) {
      console.error("Error downloading policy:", error);
      alert("Download failed.");
    }
  };

  const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (!payload.exp) return true;
    const expiryTime = payload.exp * 1000; // exp is in seconds
    return Date.now() > expiryTime;
  } catch (err) {
    console.error("Failed to decode token", err);
    return true;
  }
};

  const generateToken = async () => {
    setLoading(true);
    try {
      const accessToken = sessionStorage.getItem("accessToken");

        if (isTokenExpired(accessToken)) {
      setToastMessage("⚠️ Your session has expired. Please sign in again.");
      setShowToast(true);
      setLoading(false);
      return; // stop here
    }

      const res = await fetch(
        "https://b6hpzqf1f9.execute-api.ap-southeast-2.amazonaws.com/prod/api/token/generate",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
            Region: region,
          },
        }
      );
      logActivity({
                  userData,
                  orgId:       orgId,
                  region:      sessionStorage.getItem('userRegion') || 'AP',
                  module:      'API Integration',
                  category:    'Token',
                  action:      'Token generated',
                  
      
                  description: `Token generated`,
                ipAddress:   clientIP});

      if (!res.ok) throw new Error("Failed to generate token");

      const token = await res.text();
      setGeneratedToken(token);
      localStorage.setItem("susanGeneratedToken", token);
       setToastMessage("✅ Token generated successfully!");
    } catch (err) {
       setToastMessage("❌ Error generating token: " + err.message);
        setShowToast(true);
    } finally {
      setLoading(false);
    }
  };


  // Add this function after handleManageBilling
const fetchActiveConnections = async () => {
  if (!userData?.["cognito:username"]) return;
  
  try {
    setConnectionsLoading(true);
    
    // Fetch M365 connections
    const m365Response = await fetch('https://vaa3ne32o5.execute-api.ap-southeast-2.amazonaws.com/prod/api/m365/connections', {
      headers: {
        'userId': userData["cognito:username"],
        'Region': sessionStorage.getItem('userRegion') || 'IN'
      }
    });
    
    // Fetch Intruder connections
    const intruderResponse = await fetch('https://r8i30h7us2.execute-api.ap-southeast-2.amazonaws.com/prod/api/intruder/connections', {
      headers: {
        'userId': userData["cognito:username"],
        'Region': sessionStorage.getItem('userRegion') || 'IN'
      }
    });
    
    const m365Data = m365Response.ok ? await m365Response.json() : [];
    const intruderData = intruderResponse.ok ? await intruderResponse.json() : [];
    
    // Combine all connections
    const allConnections = [
      ...m365Data.map(conn => ({...conn, type: 'M365', icon: '🔐'})),
      ...intruderData.map(conn => ({...conn, type: 'Intruder', icon: '🛡️'}))
    ];
    
    setActiveConnections(allConnections);
  } catch (error) {
    console.error('Failed to fetch connections:', error);
  } finally {
    setConnectionsLoading(false);
  }
};


// M365 Disconnect Function
const handleDisconnectM365 = async () => {
  if (!window.confirm('Are you sure you want to disconnect Microsoft 365? This will remove the integration.')) {
    return;
  }

  try {
    const response = await fetch('https://lvnd18j7mg.execute-api.ap-southeast-2.amazonaws.com/prod/api/m365/delete-credentials', {
      method: 'DELETE',
      headers: {
        'userId': userData["cognito:username"],
        'Region': sessionStorage.getItem('userRegion') || 'IN'
      }
    });
    
    const result = await response.json();
    if (result.success) {
      setToastMessage('✅ Microsoft 365 disconnected successfully');
      logActivity({
                  userData,
                  orgId:       orgId,
                  region:      sessionStorage.getItem('userRegion') || 'AP',
                  module:      'API Integration',
                  category:    'Connection',
                  action:      'Microsoft disconnected',
                  
      
                  description: 'Microsoft disconnected',
                ipAddress:   clientIP});
      setShowToast(true);
      fetchActiveConnections(); // Refresh the list
    } else {
      setToastMessage('❌ Failed to disconnect Microsoft 365');
      setShowToast(true);
    }
  } catch (error) {
    setToastMessage('❌ Error disconnecting Microsoft 365');
    setShowToast(true);
  }
};

// Intruder Disconnect Function
const handleDisconnectIntruder = async () => {
  if (!window.confirm('Are you sure you want to disconnect Intruder.io? This will remove the integration.')) {
    return;
  }

  try {
    const response = await fetch('https://x8176cx5r6.execute-api.ap-southeast-2.amazonaws.com/prod/api/intruder/delete-credentials', {
      method: 'DELETE',
      headers: {
        'userId': userData["cognito:username"],
        'Region': sessionStorage.getItem('userRegion') || 'IN'
      }
    });
    
    const result = await response.json();
    if (result.success) {
      setToastMessage('✅ Intruder.io disconnected successfully');
       logActivity({
                  userData,
                  orgId:       orgId,
                  region:      sessionStorage.getItem('userRegion') || 'AP',
                  module:      'API Integration',
                  category:    'Connection',
                  action:      'Intruder disconnected',
                  
      
                  description: 'Intruder disconnected',
                ipAddress:   clientIP});
      setShowToast(true);
      fetchActiveConnections(); // Refresh the list
    } else {
      setToastMessage('❌ Failed to disconnect Intruder.io');
      setShowToast(true);
    }
  } catch (error) {
    setToastMessage('❌ Error disconnecting Intruder.io');
    setShowToast(true);
  }
};


  const handleCopy = (text, field) => {
    navigator.clipboard.writeText(text);
    setCopiedField(field);
    setTimeout(() => setCopiedField(""), 2000);
  };

  const renderCopyField = (label, value, fieldKey) => (
    <Row className="align-items-center mb-3">
      <Col xs={12} md={3} className="fw-semibold text-md-end text-nowrap">
        {label}:
      </Col>
      <Col xs={12} md={9} className="d-flex align-items-center gap-2">
        <div className="bg-light border rounded px-2 py-1 text-break flex-grow-1 small">
          <code className="text-dark">{value}</code>
        </div>
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip>{copiedField === fieldKey ? "Copied!" : "Copy"}</Tooltip>
          }
        >
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => handleCopy(value, fieldKey)}
            aria-label={`Copy ${label}`}
          >
            📋
          </Button>
        </OverlayTrigger>
      </Col>
    </Row>
  );

  return (

    <div>
      <ToastContainer
  position="top-end"
  className="p-3"
  style={{ marginTop: "60px" }}
>
  <Toast
    onClose={() => setShowToast(false)}
    show={showToast}
    delay={3000}
    autohide
    bg="success"
  >
    <Toast.Body className="text-white">{toastMessage}</Toast.Body>
  </Toast>
</ToastContainer>

    <Row className="g-0">
  <Col
    xs={12}
    className={`bg-transparent sidebar-container ${isSidebarCollapsed ? "collapsed" : "hello"}`}
    style={{
      width: isSidebarCollapsed ? "90px" : "317px",
      transition: "width 0.3s ease",
    }}
  >
    <Menubar
      isCollapsed={isSidebarCollapsed}
      onToggle={handleSidebarToggle}
      
    />
  </Col>



  <Col
    className="pt-0 px-0  ps-0 section-container"
    style={{
      width: `calc(100% - ${isSidebarCollapsed ? "90px" : "317px"})`,
      transition: "width 0.3s ease",
    }}
  >
    <NavigationBar
      userData={userData}
      isSidebarCollapsed={isSidebarCollapsed}
    />
    <Col className="overflow-auto p-4">
    {renderSubscriptionBanner()}
{subscriptionLoading ? (
  <div className="d-flex justify-content-center align-items-center" style={{height: '60vh'}}>
    <Spinner animation="border" variant="primary" />
    <span className="ms-3">Checking subscription...</span>
  </div>
) : (
            
            <>
             <div className={showSubscriptionModal ? "blur-content" : ""}>
                <Container fluid>
                  <h5 className="mb-4">API Setup</h5>
                  <Card className="p-4 shadow-sm mb-4">
                    <h5 className="mb-3">🔐 Universal API Token Setup</h5>
                    <p>
                      To enable log ingestion from your SIEM tool (e.g.,
                      Datadog, Splunk, Sentinel), generate a unique token and
                      configure your SIEM to forward logs to SUSAN’s secure
                      endpoint.
                    </p>

                    <Button
                      className="primaryIntegration"
                      onClick={generateToken}
                      disabled={loading}
                    >
                      {loading ? (
                        <Spinner animation="border" size="sm" />
                      ) : generatedToken ? (
                        "Regenerate Token"
                      ) : (
                        "Generate Token"
                      )}
                    </Button>

                    {generatedToken && (
                      <Alert variant="success" className="mt-4">
                        <h5 className="mb-4">✅ Configuration Details</h5>
                        <Container fluid>
                          {renderCopyField(
                            "Endpoint URL",
                            `https://api01ae173.execute-api.ap-southeast-2.amazonaws.com/prod/api/logs/ingest?region=${region}`,
                            "url"
                          )}
                          {renderCopyField(
                            "X-SUSAN-Token",
                            generatedToken,
                            "token"
                          )}
                          {renderCopyField(
                            "Content-Type",
                            "application/json",
                            "content"
                          )}
                        </Container>
                        <hr />
                        <p className="mb-0">
                          Configure your SIEM tool to POST logs to this endpoint
                          using the above token and headers.
                        </p>
                      </Alert>
                    )}
                  </Card>
 <Card className="p-4 shadow-sm mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="mb-0">🔗 Active Integrations</h5>
                      {connectionsLoading && <Spinner animation="border" size="sm" />}
                    </div>
                    
                    {connectionsLoading ? (
                      <div className="d-flex justify-content-center align-items-center py-4">
                        <Spinner animation="border" variant="primary" className="me-2" />
                        <span>Loading connections...</span>
                      </div>
                    ) : activeConnections.length === 0 ? (
                      <Alert variant="info" className="mb-0">
                        <i className="fas fa-info-circle me-2"></i>
                        No active integrations found. Connect your tools below to get started.
                      </Alert>
                    ) : (
                      <Row>
                       {activeConnections.map((connection, index) => (
  <Col md={6} lg={4} key={index} className="mb-3">
    <Card className={`h-100 border-${connection.status === 'ACTIVE' ? 'success' : 'secondary'} bg-light`}>
      <Card.Body className="d-flex flex-column">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <h6 className="mb-0 d-flex align-items-center">
            <span className="me-2" style={{ fontSize: '1.5rem' }}>
              {connection.icon}
            </span>
            {connection.type}
          </h6>
          <span className={`badge bg-${connection.status === 'ACTIVE' ? 'success' : 'secondary'}`}>
            {connection.status || 'ACTIVE'}
          </span>
        </div>
        
        <div className="mb-2">
          <small className="text-muted d-block">
            <i className="fas fa-clock me-1"></i>
            Connected: {connection.connectedAt ? 
              new Date(connection.connectedAt).toLocaleDateString() : 
              'Recently'
            }
          </small>
          
          {connection.lastActivity && (
            <small className="text-muted d-block">
              <i className="fas fa-activity me-1"></i>
              Last Activity: {new Date(connection.lastActivity).toLocaleString()}
            </small>
          )}
        </div>
        
        <div className="mt-auto">
          <Button
            variant="outline-danger"
            size="sm"
            onClick={() => {
              if (connection.type === 'M365') {
                handleDisconnectM365();
              } else if (connection.type === 'Intruder') {
                handleDisconnectIntruder();
              }
            }}
            className="w-100"
          >
            <i className="fas fa-unlink me-1"></i>
            Disconnect
          </Button>
        </div>
      </Card.Body>
    </Card>
  </Col>
))}

                      </Row>
                    )}
                  </Card>

              <Card className="p-4 shadow-sm">
  <h5 className="mb-3">⚙️ External API Integrations</h5>
  <p>
    Connect your external tools below to allow SUSAN to fetch
    logs automatically using their secure APIs.
  </p>

  <Row className="mt-3">
    <Col md={6} className="mb-3">
      <Card
        className="h-100 p-3 border rounded shadow-sm"
        onClick={() => navigate("/connect-m365")}
        style={{ cursor: "pointer" }}
      >
        <div className="d-flex align-items-center">
         <img 
            src= {micrlogo} 
            alt="Microsoft M365" 
            style={{ 
              width: "100px", 
              height: "100px", 
              marginRight: "10px",
              objectFit: "contain"
            }} 
          />
          <div>
            <h6 className="mb-1">Connect M365</h6>
            <p className="mb-0 text-muted small">
              Securely connect with Microsoft 365 to fetch
              threat intel, logs, and vulnerabilities.
            </p>
          </div>
        </div>
      </Card>
    </Col>

    <Col md={6} className="mb-3">
      <Card
        className="h-100 p-3 border rounded shadow-sm"
        onClick={() => navigate("/connect-intruder")}
        style={{ cursor: "pointer" }}
      >
        <div className="d-flex align-items-center">
          <img 
            src= {intruder} 
            alt="Intruder" 
            style={{ 
              width: "100px", 
              height: "100px", 
              marginRight: "10px",
              objectFit: "contain"
            }} 
          />
          <div>
            <h6 className="mb-1">Connect Intruder</h6>
            <p className="mb-0 text-muted small">
              Integrate Intruder.io for automated
              vulnerability scans and risk reports.
            </p>
          </div>
        </div> 
      </Card>
    </Col>

    {/*  Trend Micro Integration */}


    <Col md={6} className="mb-3">
      <Card
  className="h-100 p-3 border rounded shadow-sm"
  onClick={() => navigate("/connect-trendmicro")}
  style={{ cursor: "pointer" }}
>

        <div className="d-flex align-items-center">
          <img 
            src= {trendicon} 
            alt="Trend Micro" 
            style={{ 
              width: "80px", 
              height: "80px", 
              marginRight: "10px",
              objectFit: "contain"
            }} 
          />
          <div>
            <h6 className="mb-1">Connect Trend Micro</h6>
            <p className="mb-0 text-muted small">
              Integrate Trend Micro Vision One for advanced threat 
              detection, XDR capabilities, and comprehensive security analytics.
            </p>
          </div>
        </div> 
      </Card>
    </Col>
  </Row>

  <Row className="mt-3">
    <Col>
      <Button
        variant="outline-primary"
        onClick={() => setShowRequestModal(true)}
      >
        ➕ Request New SIEM Tool Integration
      </Button>
    </Col>
  </Row>
</Card>

                </Container>
              </div>
{showRequestModal && (
  <div className="submit-popup-overlay">
    <div className="submit-popup-content">
      <h5>Request Custom SIEM Tool Integration</h5>
      <p>Enter the name of the SIEM tool you'd like us to support:</p>
      <input
        type="text"
        className="form-control mb-3"
        placeholder="e.g., QRadar, LogRhythm, Wazuh"
        value={requestedTool}
        onChange={(e) => setRequestedTool(e.target.value)}
      />

      <div className="d-flex justify-content-end">
        <Button
          variant="secondary"
          className="me-2"
          onClick={() => setShowRequestModal(false)}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          disabled={!requestedTool || sendingRequest}
          onClick={async () => {
            setSendingRequest(true);
            try {
              await fetch("https://9gs84t7m45.execute-api.ap-southeast-2.amazonaws.com/prod/api/siem-request", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                 
                },
                body: JSON.stringify({
                  name: userData?.name,
                  email: userData?.email,
                  phone: userData?.phone_number || "N/A",
                  toolName: `SIEM Tool Integration Request: ${requestedTool}`,
                }),
              });
              setToastMessage("✅ Your SIEM integration request was sent successfully!");
                setShowToast(true);

              setRequestedTool("");
              setShowRequestModal(false);
            } catch (err) {
              alert("Failed to send request.");
              console.error(err);
            } finally {
              setSendingRequest(false);
            }
          }}
        >
          {sendingRequest ? "Sending..." : "Submit Request"}
        </Button>
      </div>
    </div>
  </div>
)}

      
   {showSubscriptionModal && (
  <div className="popup-modal">
    <div className="popup-modal-content">
     {subscriptionStatus === 'active' ? (
  <div className="text-center">
    <h5>✅ Premium Subscription Active</h5>
    <p>Your subscription is active with full access to SIEM Integration.</p>
    
    {/* ✅ ADD CLOSE BUTTON AND MANAGE BILLING FOR ACTIVE SUBSCRIPTION */}
    <div className="d-flex gap-2 justify-content-center mt-4">
      <Button 
        variant="secondary" 
        onClick={() => setShowSubscriptionModal(false)}
      >
        Close
      </Button>
       <Button 
                   variant="outline-primary" 
                   onClick={() => window.open('mailto:susan@srql.com', '_blank')}
                 >
                   Contact Support
                 </Button>
    </div>
  </div>
) : (

        <>
          <h5>
            {subscriptionStatus === 'canceled' ? (
              <>
                🔒 Premium Module Access Required<br />
                <span style={{color: 'red'}}>Your organization subscription has expired.</span>
              </>
            ) : (
              <>
                🚀 Unlock SIEM Integration<br />
                Start your trial or enter subscription key!
              </>
            )}
          </h5>

          {/* Trial/Key Options */}
         {/* Trial/Key Options */}
<div className="d-flex gap-2 justify-content-center mb-4">
  {!subscriptionStatus && (
    <Button variant="success" onClick={handleStartTrial}>
      Start Trial (15 days)
    </Button>
  )}
  
  {/* ✅ REMOVED: No more "Try Again" for canceled users */}
  {/* Only show "Try Again" for other statuses that aren't canceled */}
  {subscriptionStatus && subscriptionStatus !== 'canceled' && !secondTrialUsed && (
    <Button variant="warning" onClick={handleStartSecondTrial}>
      Try Again (15 more days)
    </Button>
  )}
</div>


        
         {/* Subscription Key Entry */}
<div className="mb-4">
  <h6>Enter Subscription Key</h6>
  <p className="text-muted small">
    Have a subscription key? Enter it below to activate premium features.
  </p>
  
  <div className="mb-3">
    <input
      type="text"
      className={`form-control text-monospace ${keyValidationError ? 'is-invalid' : ''}`}
      placeholder=""
      value={subscriptionKey}
      onChange={(e) => {
        // ✅ Allow the full license key format without auto-formatting
        const value = e.target.value.trim();
        setSubscriptionKey(value);
        setKeyValidationError('');
      }}
      disabled={isActivatingKey}
    />
    {keyValidationError && (
      <div className="invalid-feedback d-block">
        {keyValidationError}
      </div>
    )}
    <small className="text-muted">
      Enter your complete subscription key
    </small>
  </div>



  <div className="bg-light p-3 rounded mb-3">
    <h6 className="small mb-2">📧 Need a Subscription Key?</h6>
    <p className="small mb-0">
      If you don't have a subscription key, please contact <strong>susan@srql.com</strong> or visit our admin portal for key generation.
    </p>
  </div>
</div>


          {/* Action Buttons */}
          <Button 
  variant="primary" 
  onClick={handleActivateSubscriptionKey}
  disabled={isActivatingKey || !subscriptionKey.trim() || subscriptionKey.trim().length < 20} // ✅ Basic length check
>
  {isActivatingKey ? (
    <>
      <Spinner animation="border" size="sm" className="me-2" />
      Activating...
    </>
  ) : (
    <>
      <FaKey className="me-2" />
      Activate Subscription
    </>
  )}
</Button>
        </>
      )}
    </div>
  </div>
)}



  

  
  
 


            </>
          )}
          </Col>
          <BackgroundFooter isSidebarCollapsed={isSidebarCollapsed}  />
        </Col>
      </Row>

    </div>
  );
};

export default SiemIntegration;
